<template>
  <v-container>
    <v-layout text-center wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <pilot-log-data-table />
        </v-col>
        <v-col cols="12">
          <!-- ////// -->
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import PilotLogDataTable from "@/components/PilotLogDataTable";
export default {
  name: "ChiefPilotLog",
  components: {
    PilotLogDataTable
  }
};
</script>
